import {
  LAST_CHECK_SORT_ASC,
  LAST_CHECK_SORT_DEFAULT,
  LAST_CHECK_SORT_DESC,
} from './candidateListSort';

export const CANDIDATES_LIST_PATH = '/candidates-list';

const STATUS_FILTERS = new Set([
  'all',
  'pending',
  'active-seeker',
  'potential-seeker',
  'stable',
  'unavailable',
  'manual',
  'prioritized',
]);

const CONTACT_FILTERS = new Set([
  'all',
  'linkedin-blocked',
  'linkedin-available',
  'phone-missing',
  'phone-available',
]);

const SORT_VALUES = new Set([
  LAST_CHECK_SORT_DEFAULT,
  LAST_CHECK_SORT_ASC,
  LAST_CHECK_SORT_DESC,
]);

export const parseCandidatesListSearchParams = (searchParams) => {
  const status = searchParams.get('status') || 'all';
  const contact = searchParams.get('contact') || 'all';
  const sort = searchParams.get('sort') || LAST_CHECK_SORT_DEFAULT;
  const pageRaw = parseInt(searchParams.get('page') || '1', 10);

  return {
    searchTerm: searchParams.get('q') || '',
    statusFilter: STATUS_FILTERS.has(status) ? status : 'all',
    contactFilter: CONTACT_FILTERS.has(contact) ? contact : 'all',
    lastCheckSort: SORT_VALUES.has(sort) ? sort : LAST_CHECK_SORT_DEFAULT,
    currentPage: Number.isFinite(pageRaw) && pageRaw > 0 ? pageRaw - 1 : 0,
  };
};

export const buildCandidatesListSearchParams = ({
  searchTerm = '',
  statusFilter = 'all',
  contactFilter = 'all',
  lastCheckSort = LAST_CHECK_SORT_DEFAULT,
  currentPage = 0,
} = {}) => {
  const params = new URLSearchParams();
  const query = searchTerm.trim();

  if (query) params.set('q', query);
  if (statusFilter !== 'all') params.set('status', statusFilter);
  if (contactFilter !== 'all') params.set('contact', contactFilter);
  if (lastCheckSort !== LAST_CHECK_SORT_DEFAULT) params.set('sort', lastCheckSort);
  if (currentPage > 0) params.set('page', String(currentPage + 1));

  return params;
};

export const getCandidatesListPath = (filters = {}) => {
  const params = buildCandidatesListSearchParams(filters);
  const query = params.toString();
  return query ? `${CANDIDATES_LIST_PATH}?${query}` : CANDIDATES_LIST_PATH;
};

export const getCandidatesListPathFromSearchParams = (searchParams) => {
  const query = searchParams.toString();
  return query ? `${CANDIDATES_LIST_PATH}?${query}` : CANDIDATES_LIST_PATH;
};
